<template>
  <div>
    <div class="centered-header">
      <h2 class="ui header" style="color: #092442;">
        <i class="dolly flatbed icon"></i>
        <div class="content">
          New Suplier
        </div>
      </h2>
    </div>
    <div class="ui divider"></div>
    <br/>
    <div class="ui form" id="new-company-form">
      <h4 class="ui dividing header">
        Basic Information
      </h4>

      <div class="required field">
        <label for="name">{{ $t('name') }}</label>
        <div class="ui input">
          <input type="text"
                 :placeholder="'Suplier Name'"
                 v-model="suplier.name"
                 name="name">
        </div>
      </div>

      <div class="required field">
        <label for="name">{{ $t('email') }}</label>
        <div class="ui input">
          <input type="email"
                 :placeholder="'Suplier Email'"
                 v-model="suplier.email"
                 name="email">
        </div>
      </div>
      <br/>
      <h4 class="ui dividing header">
        Branches Infromation
      </h4>

      <div class="ui two column fluid grid">
        <div class="column" v-for="(branch, index) in suplier.branches" :key="index">
          <div class="ui segment">
            <div class="ui grid">
              <div class="fourteen wide column">
                <div class="centered-header">
                  <h3 class="ui header" style="color: #092442;">
                    <div class="content">
                      <i class="map marker alternate icon"></i>
                      branch # {{ index + 1 }}
                    </div>
                  </h3>
                </div>
              </div>
              <div class="one wide column">
                <div 
                  class="ui red icon right aligned very compact button" 
                  v-if="canRemoveBranch()"
                  @click="removeBranch(index)"
                >
                  <i class="close icon"></i>
                </div>
              </div>
            </div>
            <div class="ui divider">  </div>
            <div class="required field">
              <label for="name">Address</label>
              <div class="ui input">
                <input type="text"
                       :placeholder="'Address'"
                       v-model="branch.address"
                       name="address">
              </div>
            </div>

            <div v-for="(telephone, index) in branch.telephones" :key="index">
              <div class="two required fields">
                <div class="field">
                  <label for="name">Telephone Number</label>
                  <div class="ui input">
                    <input type="text"
                           :placeholder="'Number'"
                           v-model="telephone.number"
                           name="number">
                  </div>
                </div>

                <div class="field">
                  <label for="gender">Telephone Type</label>
                  <select class="ui fluid search dropdown"
                          :class="'telephone-type-search'"
                          v-model="telephone.telephone_type_id"
                          name="telephone_type">
                    <option value="">Telephone Type</option>
                    <option :value="1">Fax</option>
                    <option :value="2">Telephone</option>
                  </select>
                </div>
              </div>
            </div>
            <div 
              class="ui fluid blue button" 
              style="background-color: #092442"
              @click="addNewTelephones(branch.telephones)"
            > 
              Add Another Telephone Number
            </div>
          </div>
        </div>
        <div class="centered-header virtical-center column">
          <div class="ui huge button squared" @click="addNewBranch()">
            <div class="center aligned content" style="color: black">
              <i class="plus huge icon"></i>
              <br/>
              <br/>
              <div class="header" style="color: black">
                Add branch
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ui divider"></div>
      <div class="ui blue right floated button"
           style="background-color: #092442"
           :class="{disabled: isPressed}"
           @click="save()">
        Submit
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isPressed: false,
      suplier: {
        name: '',
        email: '',
        branches: [
          {
            address: '',
            telephones: [
              {
                number: '',
                telephone_type_id: null
              }
            ]
          }
        ]
      }
    }
  },
  mounted () {
    this.initGUI()
  },
  updated () {
    this.initGUI()
  },
  methods: {
    initGUI () {
      this.$nextTick(() => {
        $('.telephone-type-search').dropdown()

        $('#new-company-form').form({
          inline: true,
          on: 'blur',
          fields: {
            name: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter suplier name.'
                }
              ]
            },
            email: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter suplier email.'
                },
                {
                  type: 'email',
                  prompt: 'Please enter valid email.'
                }
              ]
            }
          }
        })
      })
    },
    getTelephones (telephones) {
      return window._.filter(telephones, telephone => {
        // havingNotCompletedTelephoneSlot |=
        //     !telephone.number || !telephone.telephone_type_id
        return telephone.number && telephone.telephone_type_id
      })
    },
    addNewTelephones (telephones) {
      telephones.push({
        number: '',
        telephone_type_id: null
      })
    },
    canRemoveBranch () {
      return this.suplier.branches.length > 1
    },
    removeBranch (index) {
      if (this.canRemoveBranch()) {
        this.suplier.branches.splice(index, 1)
      }
    },
    addNewBranch () {
      this.suplier.branches.push({
        address: '',
        telephones: [
          {
            number: '',
            telephone_type_id: null
          }
        ]
      })
    },
    getCleanData () {
      let newCompany = window._.cloneDeep(this.suplier)
      let branches = window._.filter(newCompany.branches, branch => {
        branch.telephones = window._.filter(branch.telephones, telephone => {
          return telephone.number && telephone.telephone_type_id
        })

        return branch.address
      })

      newCompany.branches = branches

      return newCompany
    },
    save () {
      this.isPressed = true
      this.$http.post('companies', { company: this.getCleanData() }).then(response => {
        this.navigateTo('Show_Supplier', { key: 'params', value: { id: response.data.id } })
      }).catch(() => {
        this.isPressed = false
      })
    }
  }
}
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
  }
  .virtical-center {
    display: flex !important;
    align-items: center !important;
    float: left;
  }
  .square {
    width: 300px;
    height: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/inventory_system/companies/NewCompany.vue